import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

export const QueryBox = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.grayscaleLight};
`;

export const QueryText = styled(Text)`
  font-weight: 500;
  display: flex;
  gap: 4px;
  align-items: center;
  span {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props {
  text: string;
}

const PromptBox: FC<Props> = ({ text }) => {
  return (
    <QueryBox>
      <QueryText $type="smallBold">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.99972 14.8569C11.7868 14.8569 14.8569 11.7868 14.8569 7.99972C14.8569 4.21263 11.7868 1.14258 7.99972 1.14258C4.21263 1.14258 1.14258 4.21263 1.14258 7.99972C1.14258 11.7868 4.21263 14.8569 7.99972 14.8569Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.00056 9.71415V9.14272C8.45263 9.14272 8.89455 9.00866 9.27043 8.75751C9.64632 8.50635 9.93928 8.14937 10.1123 7.73171C10.2853 7.31405 10.3305 6.85447 10.2424 6.41108C10.1542 5.9677 9.93646 5.56042 9.6168 5.24076C9.29714 4.9211 8.88986 4.7034 8.44648 4.61521C8.00309 4.52701 7.54351 4.57228 7.12585 4.74528C6.70819 4.91828 6.35121 5.21125 6.10006 5.58713C5.8489 5.96301 5.71484 6.40493 5.71484 6.857"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.99972 12.8569C8.47311 12.8569 8.85686 12.4731 8.85686 11.9997C8.85686 11.5263 8.47311 11.1426 7.99972 11.1426C7.52633 11.1426 7.14258 11.5263 7.14258 11.9997C7.14258 12.4731 7.52633 12.8569 7.99972 12.8569Z"
              fill="currentColor"
            />
          </svg>
          Prompt:
        </span>{" "}
        {text}
      </QueryText>
    </QueryBox>
  );
};

export default PromptBox;
